/**
 * menu redux reducer
 * 
 * @author    Jens Gruschel
 * @copyright © 2019 contexagon GmbH
 */


import {
    LOAD_MENU,
    SELECT_MENU_ITEM,
    SET_FILTER,
    SET_SUB_FILTERS
} from "./consts";


const initialState = {
    items: {},
    mainMenu: {},
    selectedItem: undefined,
    openedItems: [],
    currentFilter: undefined,
    initialFilter: undefined,
    subFilters: {},
};

const emptyMenu = {fields: {items: []}};


function createItemsMap(items) {
    let result = {};
    items.forEach(item => {
        const key = item.id;
        result[key] = item;
    });
    return result;
}

function findFirstFilter(menu, itemsMap) {
    if (menu && menu.fields && menu.fields.items) {
        for (const ref of menu.fields.items) {
            const item = itemsMap[ref];
            if (!item) continue; // ignore items not available or invisible to the user
            if (item.type === "menu") {
                const result = findFirstFilter(item, itemsMap);
                if (result) return result;
            }
            else if (item.type === "filter") {
                return item;
            }
        }
    }
    return undefined;
}

export default function menuReducer(state = initialState, action) {

    switch (action.type) {

        case LOAD_MENU: {

            const itemsMap = createItemsMap(action.items);
            const mainMenu = itemsMap["menu.main"] || emptyMenu;
            const initialFilter = findFirstFilter(mainMenu, itemsMap);
            console.log("initial filter", initialFilter);

            return {
                ...state,
                items: itemsMap,
                mainMenu: mainMenu,
                initialFilter: initialFilter
            };
        }

        case SELECT_MENU_ITEM: {

            return {
                ...state,
                selectedItem: action.selectedItem,
                openedItems: action.openedItems
            };
        }

        case SET_FILTER: {

            return {
                ...state,
                currentFilter: action.filter
            };
        }

        case SET_SUB_FILTERS: {

            return {
                ...state,
                subFilters: {
                    ...state.subFilters,
                    [action.filterId]: action.subFilters
                }
            };
        }

        default:
            return state;
    }
}
